module.exports = __webpack_public_path__ + "img/amy.fbc0e04e.png";